<template>
    <div>
      <md-card>
        <md-card-content>
          <md-tabs class="md-secondary" md-alignment="centered">
            <!-- SLA Rules Table -->
            <md-tab id="tab-sla-rules-table" md-label="SLA Rules">
              <SlaRuleTable />
            </md-tab>
             <!-- SLA Knock Out -->
             <md-tab id="tab-sla-knock-outs" md-label="SLA Knockouts">
              <SlaRuleKnockOut />
            </md-tab>
          </md-tabs>
        </md-card-content>
      </md-card>
    </div>
</template>

<script>
import SlaRuleTable from "./AdministrateSLARulesTable.vue";
import SlaRuleKnockOut from "./AdministrateSLARuleKnockOut.vue";

export default {
  components: {
    SlaRuleTable,
    SlaRuleKnockOut,
  },
};
</script>